/* eslint-disable tailwindcss/no-arbitrary-value */
import { graphql, useStaticQuery } from 'gatsby';
import { type FC } from 'react';

import Section from 'molecules/Section';

import { groupJobsByJobFamilyGroup } from 'components/Careers/utils/helpers';

import type { ContentfulComponentSingleInstance } from 'graphqlTypes';
import type { SectionProps } from 'molecules/Section';

export interface CareersProps extends ContentfulComponentSingleInstance, SectionProps {}

const Careers: FC<CareersProps> = ({ background, contained, contentful_id, padding, sectionIdLink }) => {
  const { allWorkdayJob } = useStaticQuery(graphql`
    query JobPostsQuery {
      allWorkdayJob(filter: { company: { eq: "Aspire" } }) {
        nodes {
          title
          url
          jobFamilyGroup
          jobFamily
          All_Locations {
            locationName
          }
          timeType
          workerSubType
          Cost_Center_Hierarchy
          Cost_Center
          timeType
          workerSubType
          jobRequisitionId
          primaryLocation
          jobDescription
          External_Apply_URL
          startDate
        }
      }
    }
  `);
  const careersData = groupJobsByJobFamilyGroup(allWorkdayJob?.nodes);

  return (
    <Section
      id={sectionIdLink}
      background={background}
      contained={contained}
      padding={padding}
      contentfulId={contentful_id}
    >
      <div className="flex flex-col items-start gap-6 border-t-[3px] border-green-500 bg-white p-6 shadow-xl md:gap-10 md:p-10">
        <h2 className="text-display-md-mobile font-bold text-gray-900 md:text-display-md">Open Positions</h2>
        <ul className="m-0 w-full">
          {careersData?.map(({ title, jobs }) => (
            <li key={title} className="flex w-full flex-col py-4">
              <p className="text-xl font-bold text-gray-900">{title}</p>
              <ul className="m-0 w-full p-0">
                {jobs?.map(job => {
                  if (!job) {
                    return null;
                  }

                  const { title: jobTitle, primaryLocation, url } = job;

                  return (
                    <li
                      key={jobTitle}
                      className="flex w-full flex-col gap-1 border-b-DEFAULT border-gray-300 p-4 px-2 py-3 md:flex-row
                      md:items-center md:justify-between md:px-6 md:py-4"
                    >
                      <a
                        href={url}
                        target="_blank"
                        rel="noreferrer"
                        className="text-md font-semibold text-green-500 hover:text-primary-600 hover:underline"
                      >
                        {jobTitle.replace(/ \((.*)\)/, '')}
                      </a>
                      <span className="text-md font-normal uppercase text-gray-700 hover:!no-underline">
                        {primaryLocation}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
};

export default Careers;
